export type AvatarNamePreview = {
    firstName: string | undefined;
    remainingNames: string[];
};

export const buildAvatarNamePreview = (
    namedItems: readonly string[],
    totalCount: number,
    moreLabel: string | null,
): AvatarNamePreview => {
    const [firstName, ...remainingNamedItems] = namedItems;
    const remainingTotal = Math.max(totalCount - 1, 0);

    // Pad with unique blanks so `+N` matches the real size; the last slot becomes the "+X more" line.
    const remainingNames = Array.from({ length: remainingTotal }, (_, index) => {
        const named = remainingNamedItems[index];
        if (named) {
            return named;
        }
        if (moreLabel !== null && index === remainingTotal - 1) {
            return moreLabel;
        }
        return " ".repeat(index + 1);
    });

    return { firstName, remainingNames };
};
